import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import * as Yup from 'yup'
import { useFormik } from "formik"
import FieldInput from "../../Components/FieldInput"
import Button from "../../Components/Button"
import RasiKattam from "../../Components/RasiKattam"
import AmsaKattam from "../../Components/AmsaKattam"
import { Dropzone, FileMosaic, resizeImage } from "@files-ui/react";
import FieldSelect from "../../Components/FieldSelect"
import FieldMultiSelect from "../../Components/FieldMultiSelect"
import axios from "axios"
import API from '../../Common/API'
import { useHistory } from 'react-router-dom'
// import PreviewRegistration from "./PreviewRegistration"
import { setAlert, setLanguage } from '../../Store/Theme/actions'
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
// import LanguageSwitcher from "../../Components/LanguageSwitcher"

const profileTypes = [{ text: 'Bride', value: 'bride' }, { text: 'Groom', value: 'groom' }]
const tProfileTypes = [{ text: 'மணமகள்', value: 'bride' }, { text: 'மணமகன்', value: 'groom' }]
const yesOrNo = [{ text: "Yes", value: true }, { text: "No", value: false }]
const salaryMode = [{ text: 'Month', value: 'month' }, { text: 'Year', value: 'year' }]
const tYesOrNo = [{ text: "ஆம்", value: true }, { text: "இல்லை", value: false }]
const tSalaryMode = [{ text: "மாதம்", value: true }, { text: "ஆண்டு", value: false }]
const pathams = [{ text: '1-ஆம் பாதம்', value: '1-ஆம் பாதம்' }, { text: '2-ஆம் பாதம்', value: '2-ஆம் பாதம்' }, { text: '3-ஆம் பாதம்', value: '3-ஆம் பாதம்' }, { text: '4-ஆம் பாதம்', value: '4-ஆம் பாதம்' }]
const maritalStatus = [{ text: 'Never Married', value: 'Never Married' }, { text: 'Divorced', value: 'Divorced' }, { text: 'Widow', value: 'Widow' }, { text: 'Widower', value: 'Widower' },{text:'Seperated',value:'seperated'}]
const tMaritalStatus = [{ text: 'திருமணம் செய்து கொள்ளவில்லை', value: 'Never Married' }, { text: 'விவாகரத்து பெற்றவர்', value: 'Divorced' }, { text: 'விதவை', value: 'Widow' }, { text: 'மனைவியை இழந்தவன்', value: 'Widower' },{text:"பிரிந்தனர்",value:'seperated'}]
const childOptions = [{ text: "0", value: "0" }, { text: "1", value: "1" }, { text: "2", value: "2" }, { text: "3", value: "3" }, { text: "4", value: "4" }, { text: "5", value: "5" }, { text: 'More than 5', value: 'More than 5' }]

const initialRegisterForm = {
    profileType: '',
    educationalQualification: '',
    firstName: '',
    lastName: '',
    surname: '',
    tFirstName: '',
    tLastName: '',
    tSurname: '',
    height: '',
    heightInFeet: '',
    occupationDetail: "",
    otherEducationalQualification: "",
    salaryMode: '',
    dateOfBirth: '',
    images: [],
    rasiKattam: [],
    amsaKattam: [],
    password: '',
    birthTime: "",
    birthPlace: "",
    thisaiIruppu: "",
    thisaiIruppuDate: "",
    thisaiIruppuMonth: "",
    thisaiIruppuYear: "",
    maritalStatus: "",
    noOfChild: "",
    childDetails: "",
    confirmPassword: '',
    contactInformation: {
        mobileNumber: '',
        whatsappNumber: '',
        nativeAddress: {
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            district: '',
            pinCode: ''
        },
        presentAddress: {
            addressLine1: '',
            addressLine2: '',
            district: '',
            city: '',
            state: '',
            pinCode: '',
            district: '',
        },
        isSameAddress: false,
        email: ''
    },
    familyInformation: {
        fatherFirstName: '',
        fatherLastName: '',
        fatherSurname: '',
        motherFirstName: '',
        motherLastName: '',
        motherSurname: '',
        fatherNative: '',
        motherNative: '',
        fatherOccupation: '',
        motherOccupation: '',
        isFatherAlive: true,
        isMotherAlive: true,
        numberOfSibilings: 0,
        numberOfMaleSibilings: 0,
        numberOfFemaleSibilings: 0
    },
    additionalInformation: {
        zodiacSign: '',
        star: '',
        flaws: [],
        padtham:'',
        // ascendant: '',
        expectedZodiacSigns: [],
        expectedStars: [],
        expectedPersonality: [],
        expectedEducationalQualification: '',
        expectedOccupation: '',
        expectedSalary: '',
        expectedStatus: '',
        expectation: ''
    }
}


const CreateUser = ({ }) => {

    const [files, setFiles] = React.useState([]);
    const [pType, setPType] = useState()
    // const [zodiacSigns, setZodiacSigns] = useState([])
    const zodiacSigns =  useSelector((state)=>state.auth.zodiacSigns)
    const flaws = useSelector((state)=>state.auth.flaws)
    const tFlaws = useSelector((state)=>state.auth.tFlaws)
    const [fileUrls, setFileUrls] = useState([])
    const [rasiValues, setRasiValues] = useState([
        [], [], [], [],
        [], null, null, [],
        [], null, null, [],
        [], [], [], []
    ]);

    const [amsaValues, setAmsaValues] = useState([
        [], [], [], [],
        [], null, null, [],
        [], null, null, [],
        [], [], [], []
    ]);
    const [stars, setStars] = useState([])
    const status = useSelector((state)=>state.auth.status)
    const tStatus = useSelector((state)=>state.auth.tStatus)
    const allStars = useSelector((state)=>state.auth.allStars)
    const occupation = useSelector((state)=>state.auth.occupation)
    const tOccupation = useSelector((state)=>state.auth.tOccupation)
    const [previewDialog, setPreviewDialog] = useState(false)
    const dispatch = useDispatch()
    const history = useHistory()
    const [submitDisabled, setSubmitDisabled] = useState(false)
    const { t } = useTranslation()
    const lang = useSelector((state) => state.theme.language)
    const [screenLoading, setScreenLoading] = useState(false)
    const [heightType, setHeightType] = useState('cm')
    const [childDetails, setChildDetails] = useState(false)
    const [mobileAlreadyExists, setMobileAlreadyExists] = useState(false)


    const registerFormSchema = Yup.object().shape({
        profileType: Yup.string().required("Profile type is required"),
        // educationalQualification: Yup.array().required("Educational Qualification is required"),
        firstName: Yup.string().required("First Name is required"),
        // lastName: Yup.string().required("Last Name is required"),
        surname: Yup.string().required("Surname is required"),
        tFirstName: Yup.string().nullable(),
        // tLastName: Yup.string().nullable(),
        profession: Yup.string().nullable(),
        occuapation: Yup.string().nullable(),
        tSurname: Yup.string().nullable(),
        dateOfBirth: Yup.string().required("Date of birth is required"),
        heightInFeet: Yup.string().nullable(),
        height: Yup.number().required("Required"),
        images: Yup.array(),
        rasiKattam: Yup.array(),
        amsaKattam: Yup.array(),
        birthTime: Yup.string().nullable(),
        birthPlace: Yup.string().nullable(),
        thisaiIruppu: Yup.string().nullable(),
        thisaiIruppuDate: Yup.string().nullable(),
        thisaiIruppuMonth: Yup.string().nullable(),
        thisaiIruppuYear: Yup.string().nullable(),
        maritalStatus: Yup.string().nullable(),
        noOfChild: Yup.string().nullable(),
        childDetails: Yup.string().nullable(),
        otherEducationalQualification: Yup.string().nullable(),
        familyInformation: Yup.object().shape({
            fatherFirstName: Yup.string().required("Required"),
            // fatherLastName: Yup.string().required("Required"),
            fatherSurname: Yup.string().required("Required"),
            motherFirstName: Yup.string().required("Required"),
            // motherLastName: Yup.string().required("Required"),
            motherSurname: Yup.string().required("Required"),
            fatherOccupation: Yup.string().nullable(),
            fatherNative: Yup.string().nullable(),
            motherNative: Yup.string().nullable(),
            motherOccupation: Yup.string().nullable(),
            isFatherAlive: Yup.boolean(),
            isMotherAlive: Yup.boolean(),
            numberOfSibilings: Yup.number(),
            numberOfMaleSibilings: Yup.number(),
            numberOfFemaleSibilings: Yup.number(),
            marriedFemaleSiblings: Yup.number(),
            marriedMaleSiblings: Yup.number(),
            siblingsDetails: Yup.string().nullable()
        }),
        contactInformation: Yup.object().shape({
            mobileNumber: Yup.string().required("Mobile number is required"),
            whatsappNumber: Yup.string().nullable(),
            nativeAddress: Yup.object().shape({
                addressLine1: Yup.string().required("Address Line 1 is required"),
                addressLine2: Yup.string().nullable(),
                city: Yup.string().required("City is required"),
                state: Yup.string().required("State is required"),
                district: Yup.string().required("District is required"),
                pinCode: Yup.string().required("Pincode is required")
            }),
            presentAddress: Yup.object().shape({
                addressLine1: Yup.string().required("Address Line 1 is required"),
                addressLine2: Yup.string().nullable(),
                city: Yup.string().required("City is required"),
                state: Yup.string().required("State is required"),
                district: Yup.string().required("District is required"),
                pinCode: Yup.string().required("Pincode is required")
            }),
            isSameAddress: Yup.boolean(),
            email: Yup.string().nullable(),
        }),
        additionalInformation: Yup.object().shape({
            zodiacSign: Yup.string().required("Required"),
            star: Yup.string().required("Required"),
            flaws: Yup.array(),
            padham: Yup.string().nullable(),
            // ascendant: Yup.string().required("Required"),
            expectedZodiacSigns: Yup.array(),
            expectedStars: Yup.array(),
            expectedPersonality: Yup.array(),
            expectedEducationalQualification: Yup.string().nullable(),
            expectedOccupation: Yup.array(),
            expectedSalary: Yup.string().nullable(),
            expectedStatus: Yup.array(),
            expectation: Yup.string().nullable()
            // password: Yup.string().required("Password is required"),
            // confirmPassword: Yup.string().required("Confirm Password is required"),
        })
    })



    const registerForm = useFormik({
        initialValues: initialRegisterForm,
        validateOnMount: true,
        validationSchema: registerFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {

            setSubmitDisabled(true)
            setScreenLoading(true)
            values.heightInFeet = `${values.heightInFeet.split('.')[0]} ft ${values.heightInFeet.split('.')[1]} in`
            values.directApproval = true
            values.additionalInformation.password = values.password
            values.additionalInformation.confirmPassword = values.confirmPassword
            const formData = new FormData();
            formData.append('userData', JSON.stringify(values));
            files.forEach((file) => {
                formData.append('files', file.file);
            });
            if (mobileAlreadyExists) {
                setSubmitDisabled(false)
                setScreenLoading(false)
                dispatch(setAlert({ type: 'error', title: 'Mobile Number Already Exists', subtitle: 'This mobile number is already registered.', active: true }))
                return;
            } else {
                if (values.password === values.confirmPassword) {
                    API.post('/auth/register', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((res) => {
                        if (res.status === 200 && res.data.data.error) {
                            setSubmitDisabled(false)
                            setScreenLoading(false)
                            dispatch(setAlert({ type: 'error', title: 'Registration Failed', subtitle: res.data.data.message, active: true }))
                            return;
                        } else if (res.status === 200) {
                            dispatch(setAlert({ type: 'success', title: 'Registration Success', subtitle: 'Your registration is successfull.', active: true }))
                            setSubmitDisabled(false)
                            setScreenLoading(false)
                            registerForm.resetForm()
                        }
                    }).catch((err) => {
                        setSubmitDisabled(false)
                    })
                } else {
                    setSubmitDisabled(false)
                    setScreenLoading(false)
                    registerForm.setErrors({ 'confirmPassword': 'Password and Confirm Password should be same' })
                }
            }
        }
    })


    const convertHeight = (cm) => {
        const totalInches = parseInt(cm) * 0.3937;
        const feet = Math.floor(totalInches / 12);
        const inches = Math.round(totalInches % 12);
        registerForm.setValues({ ...registerForm.values, heightInFeet: `${feet}.${inches}` })
    };

    const convertHeightToCm = (feet) => {
        const cm = Math.round(parseFloat(feet) * 30.48);
        registerForm.setValues({ ...registerForm.values, height: cm })
    }



    const updateFiles = (incommingFiles) => {
        setFiles(incommingFiles);

        const newUrls = incommingFiles.map((file) => URL.createObjectURL(file.file));
        setFileUrls(newUrls);
        //even your own upload implementation
    };
    const removeFile = (id) => {
        const updatedFiles = files.filter((x) => x.id !== id);
        const removedFileIndex = files.findIndex((file) => file.id === id); //find the index of the removed file

        setFiles(updatedFiles);

        // Remove the corresponding URL
        setFileUrls((prevUrls) => {
            const newUrls = [...prevUrls];
            newUrls.splice(removedFileIndex, 1); // Remove the url at the same index
            return newUrls;
        });
    };

    const getStarsByZodiac = (values) => {
        API.post(`/common/getStarByZodiac`, { zodiacId: values }).then((starRes) => {
            if (starRes.status === 200) {
                setStars(starRes.data.data.map((c) => { return { text: c.star, value: c._id } }))
            }
        })
    }

    const getPresentAddress = (values) => {
        if (values.length === 6) {
            API.get(`/common/getLocationByPincode?pinCode=${parseInt(values)}`).then((locationRes) => {
                if (locationRes.status === 200) {
                    const location = locationRes.data.data;
                    registerForm.setValues((prevValues) => ({
                        ...prevValues,
                        contactInformation: {
                            ...prevValues.contactInformation,
                            presentAddress: {
                                ...prevValues.contactInformation.presentAddress,
                                city: location.city,
                                state: location.state,
                                district: location.district,
                                pinCode: location.pinCode
                            }
                        }
                    }));
                }
            });
        } else if (values.length === 0) {
            registerForm.setValues((prevValues) => ({
                ...prevValues,
                contactInformation: {
                    ...prevValues.contactInformation,
                    presentAddress: {
                        ...prevValues.contactInformation.presentAddress,
                        city: '',
                        state: '',
                        district: '',
                        pinCode: ''
                    }
                }
            }));
        }
    };

    const getNativeAddress = (values) => {
        if (values.length === 6) {
            API.get(`/common/getLocationByPincode?pinCode=${parseInt(values)}`).then((locationRes) => {
                if (locationRes.status === 200) {
                    const location = locationRes.data.data;
                    registerForm.setValues((prevValues) => ({
                        ...prevValues,
                        contactInformation: {
                            ...prevValues.contactInformation,
                            nativeAddress: {
                                ...prevValues.contactInformation.nativeAddress,
                                city: location.city, // fixed typo from location.ciy
                                state: location.state,
                                district: location.district,
                                pinCode: location.pinCode
                            }
                        }
                    }));
                }
            });
        } else if (values.length === 0) {
            registerForm.setValues((prevValues) => ({
                ...prevValues,
                contactInformation: {
                    ...prevValues.contactInformation,
                    nativeAddress: {
                        ...prevValues.contactInformation.nativeAddress,
                        city: '',
                        state: '',
                        district: '',
                        pinCode: ''
                    }
                }
            }));
        }
    };

    const sameAddress = (e) => {
        const isChecked = e.target.checked;
        registerForm.setValues((prevValues) => ({
            ...prevValues,
            contactInformation: {
                ...prevValues.contactInformation,
                isSameAddress: isChecked,
                nativeAddress: isChecked
                    ? { ...prevValues.contactInformation.presentAddress }
                    : {
                        addressLine1: '',
                        addressLine2: '',
                        city: '',
                        state: '',
                        district: '',
                        pinCode: ''
                    }
            }
        }));
    };
    const translateValues = (value, key, actualValue) => {
        if (lang === 'ta' && key === 'firstName') {
            registerForm.setValues({ ...registerForm.values, firstName: actualValue, tFirstName: value })
        } else if (lang === 'ta' && key === 'lastName') {
            registerForm.setValues({ ...registerForm.values, lastName: actualValue, tLastName: value })
        } else if (lang === 'ta' && key === 'surname') {
            registerForm.setValues({ ...registerForm.values, surname: actualValue, tSurname: value })
        }
    }

    const handleMobileNumber = (values) => {
        if (values.length === 10) {
            API.post(`/common/mobileAlreadyExists`, { mobileNumber: values }).then((valueRes) => {
                if (valueRes.status === 200) {
                    setMobileAlreadyExists(false)
                }
            }).catch((err) => {
                setMobileAlreadyExists(true)
                dispatch(setAlert({ type: 'error', title: 'Mobile Number Already Exists', subtitle: 'This mobile number is already registered.', active: true }))
            })
        }
    }

    const checkForKids = (values) => {
        if (values !== 'Never Married') {
            setChildDetails(true)
        }
    }

    return (
        <motion.div className="min-h-screen w-full h-full overflow-y-scroll flex flex-col lg:px-10 py-10 registerBg relative">
            <motion.div className="w-full flex flex-row py-10 px-2 md:px-0 justify-between">
                <motion.div className="flex flex-row justify-between items-center">
                    {/* <LanguageSwitcher onToggle={(lang) => dispatch(setLanguage(lang))} /> */}
                </motion.div>
            </motion.div>
            {/* Page 1 */}
            <motion.div className="h-full w-full grid grid-cols-1 gap-10">
                <motion.div className="w-full gap-2 flex flex-col h-full justify-center">
                    <p className="text-4xl font-bold text-primeColor">{t('Basic Information')}</p>
                </motion.div>
                <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldSelect
                        injectClass={'bg-white'}
                        label={t('Bride/Groom')}
                        fieldProps={registerForm.getFieldProps('profileType')}
                        fieldMeta={registerForm.getFieldMeta('profileType')}
                        fieldHelper={registerForm.getFieldHelpers('profileType')}
                        edit={true}
                        dataLoaded={true}
                        options={lang === 'en' ? profileTypes : tProfileTypes}
                        onChange={(ev) => setPType(profileTypes.filter((x) => x.value === ev)[0].text)}
                    />
                    <FieldInput label={t(`Educational Qualification`)} injectClass={'bg-white'} fieldProps={registerForm.getFieldProps('otherEducationalQualification')} fieldHelper={registerForm.getFieldHelpers('otherEducationalQualification')} fieldMeta={registerForm.getFieldMeta('otherEducationalQualification')} edit={true} dataLoaded={true} />
                    <FieldSelect
                        injectClass={'bg-white'}
                        label={t('Marital Status')}
                        fieldProps={registerForm.getFieldProps('maritalStatus')}
                        fieldMeta={registerForm.getFieldMeta('maritalStatus')}
                        fieldHelper={registerForm.getFieldHelpers('maritalStatus')}
                        edit={true}
                        dataLoaded={true}
                        options={lang === 'en' ? maritalStatus : tMaritalStatus}
                        onChange={(ev) => checkForKids(ev)}
                    />
                    {childDetails && <FieldSelect injectClass={'bg-white'} label={t('No of childs')} fieldProps={registerForm.getFieldProps('noOfChild')} fieldHelper={registerForm.getFieldHelpers('noOfChild')} fieldMeta={registerForm.getFieldMeta('noOfChild')} edit={true} dataLoaded={true} options={childOptions} />}
                    {registerForm.values.noOfChild !== "0" && registerForm.values.noOfChild !== '' && registerForm.values.noOfChild !== null && <FieldInput type='textarea' injectClass={'bg-white'} label={'Child Details'} fieldProps={registerForm.getFieldProps('childDetails')} fieldHelper={registerForm.getFieldHelpers('childDetails')} fieldMeta={registerForm.getFieldMeta('childDetails')} edit={true} dataLoaded={true} />}
                </motion.div>
                <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`${pType ? pType : ''} First Name`)} fieldProps={lang === 'ta' ? registerForm.getFieldProps('tFirstName') : registerForm.getFieldProps('firstName')} fieldMeta={lang === 'ta' ? registerForm.getFieldMeta('tFirstName') : registerForm.getFieldMeta('firstName')} fieldHelper={lang === 'ta' ? registerForm.getFieldHelpers('tFirstName') : registerForm.getFieldHelpers('firstName')} edit={true} dataLoaded={true} onChange={(ev) => translateValues(ev.translatedValue, 'firstName', ev.value)} />
                    {/* <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`${pType ? pType : ''} Last Name`)} fieldProps={lang === 'ta' ? registerForm.getFieldProps('tLastName') : registerForm.getFieldProps('lastName')} fieldMeta={lang === 'ta' ? registerForm.getFieldMeta('tLastName') : registerForm.getFieldMeta('lastName')} fieldHelper={lang === 'ta' ? registerForm.getFieldHelpers('tLastName') : registerForm.getFieldHelpers('lastName')} edit={true} dataLoaded={true} onChange={(ev) => translateValues(ev.translatedValue, 'lastName', ev.value)} /> */}
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`${pType ? pType : ''} Surname`)} fieldProps={lang === 'ta' ? registerForm.getFieldProps('tSurname') : registerForm.getFieldProps('surname')} fieldMeta={lang === 'ta' ? registerForm.getFieldMeta('tSurname') : registerForm.getFieldMeta('surname')} fieldHelper={lang === 'ta' ? registerForm.getFieldHelpers('tSurname') : registerForm.getFieldHelpers('surname')} edit={true} dataLoaded={true} onChange={(ev) => translateValues(ev.translatedValue, 'surname', ev.value)} />
                    <FieldInput type="date" dateInjectClass={'bg-white'} label={t(`Date of birth`)} fieldProps={registerForm.getFieldProps('dateOfBirth')} fieldMeta={registerForm.getFieldMeta('dateOfBirth')} fieldHelper={registerForm.getFieldHelpers('dateOfBirth')} edit={true} dataLoaded={true} />
                    {/* <FieldInput injectClass={'bg-white'} label={t(`${pType ? pType : ''} Height In Cm`)} fieldProps={registerForm.getFieldProps('height')} fieldMeta={registerForm.getFieldMeta('height')} fieldHelper={registerForm.getFieldHelpers('height')} edit={true} dataLoaded={true} onChange={(ev) => convertHeight(ev)} /> */}
                    <motion.div className="flex flex-col gap-2">
                        <label className="font-medium text-sm">{t('Choose height measurement')}</label>

                        <motion.div className="flex items-center gap-4">
                            <label className="flex items-center gap-1">
                                <input
                                    type="radio"
                                    name="heightUnit"
                                    checked={heightType === 'cm'}
                                    onChange={() => setHeightType('cm')}
                                    className="accent-blue-500"
                                />
                                <span>{t('In CM')}</span>
                            </label>

                            <label className="flex items-center gap-1">
                                <input
                                    type="radio"
                                    name="heightUnit"
                                    checked={heightType === 'ft'}
                                    onChange={() => setHeightType('ft')}
                                    className="accent-blue-500"
                                />
                                <span>{t('In Feet')}</span>
                            </label>
                        </motion.div>
                    </motion.div>
                    <FieldInput injectClass={'bg-white'} label={t(`Height In ${heightType === 'cm' ? 'CM' : 'Feet'}`)} fieldProps={heightType === 'cm' ? registerForm.getFieldProps('height') : registerForm.getFieldProps('heightInFeet')}
                        fieldMeta={heightType === 'cm' ? registerForm.getFieldMeta('height') : registerForm.getFieldProps('heightInFeet')} fieldHelper={heightType === 'cm' ? registerForm.getFieldHelpers('height') : registerForm.getFieldProps('heightInFeet')} edit={true} dataLoaded={true} onChange={(ev) => heightType === 'cm' ? convertHeight(ev) : convertHeightToCm(ev)} />
                    <FieldSelect injectClass={'bg-white'} label={t(`Profession`)} fieldProps={registerForm.getFieldProps('profession')} fieldMeta={registerForm.getFieldMeta('profession')} fieldHelper={registerForm.getFieldHelpers('profession')} edit={true} dataLoaded={true} options={lang === 'en' ? occupation : tOccupation} />
                    <FieldInput injectClass={'bg-white'} label={t(`${pType ? pType : ''} Occupation`)} placeholder="Software Engineer/ Pediatrician/ " fieldProps={registerForm.getFieldProps('occupation')} fieldMeta={registerForm.getFieldMeta('occupation')} fieldHelper={registerForm.getFieldHelpers('occupation')} edit={true} dataLoaded={true} />
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`${pType ? pType : ''} Occupation Location`)} fieldProps={registerForm.getFieldProps('occupationLocation')} fieldMeta={registerForm.getFieldMeta('occupationLocation')} fieldHelper={registerForm.getFieldHelpers('occupationLocation')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`${pType ? pType : ''} Salary`)} fieldProps={registerForm.getFieldProps('salary')} fieldMeta={registerForm.getFieldMeta('salary')} fieldHelper={registerForm.getFieldHelpers('salary')} edit={true} dataLoaded={true} />
                    <FieldSelect injectClass={'bg-white'} label={t(`${pType ? pType : ''} Salary Mode`)} fieldProps={registerForm.getFieldProps('salaryMode')} fieldMeta={registerForm.getFieldMeta('salaryMode')} fieldHelper={registerForm.getFieldHelpers('salaryMode')} edit={true} dataLoaded={true} options={lang === 'en' ? salaryMode : tSalaryMode} />
                </motion.div>
            </motion.div>
            {/* Page 2 */}
            <motion.div className="h-full w-full grid grid-cols-1 gap-10">
                <motion.div className="w-full flex gap-2 flex-col h-full justify-center">
                    <p className="text-4xl font-bold text-primeColor">{t('Family Information')}</p>
                </motion.div>
                <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Father First Name`)} fieldProps={registerForm.getFieldProps('familyInformation.fatherFirstName')} fieldMeta={registerForm.getFieldMeta('familyInformation.fatherFirstName')} fieldHelper={registerForm.getFieldHelpers('familyInformation.fatherFirstName')} edit={true} dataLoaded={true} />
                    {/* <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Father Last Name`)} fieldProps={registerForm.getFieldProps('familyInformation.fatherLastName')} fieldMeta={registerForm.getFieldMeta('familyInformation.fatherLastName')} fieldHelper={registerForm.getFieldHelpers('familyInformation.fatherLastName')} edit={true} dataLoaded={true} /> */}
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Father Surname`)} fieldProps={registerForm.getFieldProps('familyInformation.fatherSurname')} fieldMeta={registerForm.getFieldMeta('familyInformation.fatherSurname')} fieldHelper={registerForm.getFieldHelpers('familyInformation.fatherSurname')} edit={true} dataLoaded={true} />
                    <FieldSelect injectClass={'bg-white'} label={t('Father is alive?')} fieldProps={registerForm.getFieldProps('familyInformation.isFatherAlive')} fieldMeta={registerForm.getFieldMeta('familyInformation.isFatherAlive')} fieldHelper={registerForm.getFieldHelpers('familyInformation.isFatherAlive')} edit={true} dataLoaded={true} options={lang === 'en' ? yesOrNo : tYesOrNo} />
                    <FieldInput injectClass={'bg-white'} label={t(`Father Occupation`)} fieldProps={registerForm.getFieldProps('familyInformation.fatherOccupation')} fieldMeta={registerForm.getFieldMeta('familyInformation.fatherOccupation')} fieldHelper={registerForm.getFieldHelpers('familyInformation.fatherOccupation')} edit={true} dataLoaded={true} />
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Mother First Name`)} fieldProps={registerForm.getFieldProps('familyInformation.motherFirstName')} fieldMeta={registerForm.getFieldMeta('familyInformation.motherFirstName')} fieldHelper={registerForm.getFieldHelpers('familyInformation.motherFirstName')} edit={true} dataLoaded={true} />
                    {/* <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Mother Last Name`)} fieldProps={registerForm.getFieldProps('familyInformation.motherLastName')} fieldMeta={registerForm.getFieldMeta('familyInformation.motherLastName')} fieldHelper={registerForm.getFieldHelpers('familyInformation.motherLastName')} edit={true} dataLoaded={true} /> */}
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Mother Surname`)} fieldProps={registerForm.getFieldProps('familyInformation.motherSurname')} fieldMeta={registerForm.getFieldMeta('familyInformation.motherSurname')} fieldHelper={registerForm.getFieldHelpers('familyInformation.motherSurname')} edit={true} dataLoaded={true} />
                    <FieldSelect injectClass={'bg-white'} label={t('Mother is alive?')} fieldProps={registerForm.getFieldProps('familyInformation.isMotherAlive')} fieldMeta={registerForm.getFieldMeta('familyInformation.isMotherAlive')} fieldHelper={registerForm.getFieldHelpers('familyInformation.isMotherAlive')} edit={true} dataLoaded={true} options={lang === 'en' ? yesOrNo : tYesOrNo} />
                    <FieldInput injectClass={'bg-white'} label={t(`Mother Occupation`)} fieldProps={registerForm.getFieldProps('familyInformation.motherOccupation')} fieldMeta={registerForm.getFieldMeta('familyInformation.motherOccupation')} fieldHelper={registerForm.getFieldHelpers('familyInformation.motherOccupation')} edit={true} dataLoaded={true} />
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Father Native`)} fieldProps={registerForm.getFieldProps('familyInformation.fatherNative')} fieldMeta={registerForm.getFieldMeta('familyInformation.fatherNative')} fieldHelper={registerForm.getFieldHelpers('familyInformation.fatherNative')} edit={true} dataLoaded={true} />
                    <FieldInput translate={lang === 'ta' ? true : false} injectClass={'bg-white'} label={t(`Mother Native`)} fieldProps={registerForm.getFieldProps('familyInformation.motherNative')} fieldMeta={registerForm.getFieldMeta('familyInformation.motherNative')} fieldHelper={registerForm.getFieldHelpers('familyInformation.motherNative')} edit={true} dataLoaded={true} />
                    {/* <FieldInput injectClass={'bg-white'} label={t(`Number of siblings`)} fieldProps={registerForm.getFieldProps('familyInformation.numberOfSiblings')} fieldMeta={registerForm.getFieldMeta('familyInformation.numberOfSiblings')} fieldHelper={registerForm.getFieldHelpers('familyInformation.numberOfSiblings')} edit={true} dataLoaded={true} /> */}
                    <FieldInput injectClass={'bg-white'} label={t(`No of male siblings`)} fieldProps={registerForm.getFieldProps('familyInformation.numberOfMaleSiblings')} fieldMeta={registerForm.getFieldMeta('familyInformation.numberOfMaleSiblings')} fieldHelper={registerForm.getFieldHelpers('familyInformation.numberOfMaleSiblings')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`No of female siblings`)} fieldProps={registerForm.getFieldProps('familyInformation.numberOfFemaleSiblings')} fieldMeta={registerForm.getFieldMeta('familyInformation.numberOfFemaleSiblings')} fieldHelper={registerForm.getFieldHelpers('familyInformation.numberOfFemaleSiblings')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`No of female married siblings`)} fieldProps={registerForm.getFieldProps('familyInformation.marriedFemaleSiblings')} fieldMeta={registerForm.getFieldMeta('familyInformation.marriedFemaleSiblings')} fieldHelper={registerForm.getFieldHelpers('familyInformation.marriedFemaleSiblings')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`No of male married siblings`)} fieldProps={registerForm.getFieldProps('familyInformation.marriedMaleSiblings')} fieldMeta={registerForm.getFieldMeta('familyInformation.marriedMaleSiblings')} fieldHelper={registerForm.getFieldHelpers('familyInformation.marriedMaleSiblings')} edit={true} dataLoaded={true} />
                    <motion.div className="col-span-2">
                        <FieldInput injectClass={'bg-white'} type="textarea" label={t(`Siblings Details`)} fieldProps={registerForm.getFieldProps('familyInformation.siblingsDetails')} fieldHelper={registerForm.getFieldHelpers('familyInformation.siblingsDetails')} fieldMeta={registerForm.getFieldMeta('familyInformation.siblingsDetails')} edit={true} dataLoaded={true} />
                    </motion.div>
                </motion.div>
            </motion.div>
            {/* Page 3 */}
            <motion.div className="h-full w-full grid grid-cols-1 gap-10">
                <motion.div className="w-full flex gap-2 px-1 flex-col h-full justify-center">
                    <p className="text-4xl font-bold text-primeColor">{t('Additional Information')}</p>
                </motion.div>
                <motion.div className="w-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldSelect injectClass={'bg-white'} label={t('Zodiac Sign')} fieldProps={registerForm.getFieldProps('additionalInformation.zodiacSign')} fieldMeta={registerForm.getFieldMeta('additionalInformation.zodiacSign')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.zodiacSign')} edit={true} dataLoaded={true} options={zodiacSigns} onChange={(ev) => { getStarsByZodiac(ev) }} />
                    <FieldSelect injectClass={'bg-white'} placeholder={t('Star')} label={t(`Star`)} fieldProps={registerForm.getFieldProps('additionalInformation.star')} fieldMeta={registerForm.getFieldMeta('additionalInformation.star')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.star')} edit={true} dataLoaded={true} options={stars} />
                    <FieldSelect injectClass={'bg-white'} placeholder={t('Padham')} label={t(`Padham`)} fieldProps={registerForm.getFieldProps('additionalInformation.padham')} fieldMeta={registerForm.getFieldMeta('additionalInformation.padham')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.padham')} edit={true} dataLoaded={true} options={pathams} />
                    <FieldMultiSelect injectClass={'bg-white'} placeholder={t('Flaws')} label={t(`Flaws`)} fieldProps={registerForm.getFieldProps('additionalInformation.flaws')} fieldMeta={registerForm.getFieldMeta('additionalInformation.flaws')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.flaws')} edit={true} dataLoaded={true} options={lang === 'en' ? flaws : tFlaws} />
                    <div></div>
                </motion.div>
                <motion.div className="w-full flex px-1 gap-2 flex-col my-5 justify-center">
                    <p className="text-xl font-bold text-primeColor">{t('Expectations')}</p>
                </motion.div>
                <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldMultiSelect injectClass={'bg-white'} label={t(`Zodiac Sign`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectedZodiacSigns')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedZodiacSigns')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedZodiacSigns')} edit={true} dataLoaded={true} options={zodiacSigns} />
                    <FieldMultiSelect injectClass={'bg-white'} label={t('Stars')} fieldProps={registerForm.getFieldProps('additionalInformation.expectedStars')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedStars')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedStars')} edit={true} dataLoaded={true} options={allStars} />
                    {/* <FieldInput injectClass={'bg-white'} label={`Perssonality`} fieldProps={registerForm.getFieldProps('expectedPersonality')} fieldMeta={registerForm.getFieldMeta('expectedPersonality')} fieldHelper={registerForm.getFieldHelpers('expectedPersonality')} edit={true} dataLoaded={true} /> */}
                    <FieldInput injectClass={'bg-white'} label={t(`Educational Qualification`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectedEducationalQualification')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedEducationalQualification')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedEducationalQualification')} edit={true} dataLoaded={true} />
                    <FieldMultiSelect injectClass={'bg-white'} label={t(`Profession`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectedOccupation')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedOccupation')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedOccupation')} edit={true} dataLoaded={true} options={lang === 'en' ? occupation : tOccupation} />
                    <FieldInput injectClass={'bg-white'} label={t(`Salary`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectedSalary')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedSalary')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedSalary')} edit={true} dataLoaded={true} />
                    <FieldMultiSelect injectClass={'bg-white'} label={t(`Status`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectedStatus')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectedStatus')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectedStatus')} edit={true} dataLoaded={true} options={lang === 'en' ? status : tStatus} />
                    <FieldInput injectClass={'bg-white'} label={t(`Expectation`)} fieldProps={registerForm.getFieldProps('additionalInformation.expectation')} fieldMeta={registerForm.getFieldMeta('additionalInformation.expectation')} fieldHelper={registerForm.getFieldHelpers('additionalInformation.expectation')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} type="password" label={t(`Password`)} fieldProps={registerForm.getFieldProps('password')} fieldMeta={registerForm.getFieldMeta('password')} fieldHelper={registerForm.getFieldHelpers('password')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} type="password" label={t(`Confirm Password`)} fieldProps={registerForm.getFieldProps('confirmPassword')} fieldMeta={registerForm.getFieldMeta('confirmPassword')} fieldHelper={registerForm.getFieldHelpers('confirmPassword')} edit={true} dataLoaded={true} />
                </motion.div>
            </motion.div>
            {/* Page 4 */}
            <motion.div className="h-full w-full grid grid-cols-1 gap-10">
                <motion.div className="w-full flex px-1 gap-2 flex-col h-full py-5 justify-center">
                    <p className="text-4xl font-bold text-primeColor">{t('Contact Information')}</p>
                </motion.div>
                <motion.div className="w-full grid grid-cols-1 md:grid-cols-3 sm:grid-cols-1 gap-5">
                    <FieldInput injectClass={'bg-white'} type="phone" label={t('Mobile Number')} fieldProps={registerForm.getFieldProps('contactInformation.mobileNumber')} fieldMeta={registerForm.getFieldMeta('contactInformation.mobileNumber')} fieldHelper={registerForm.getFieldHelpers('contactInformation.mobileNumber')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} type="phone" label={t('Whatsapp Number')} fieldProps={registerForm.getFieldProps('contactInformation.whatsappNumber')} fieldMeta={registerForm.getFieldMeta('contactInformation.whatsappNumber')} fieldHelper={registerForm.getFieldHelpers('contactInformation.whatsappNumber')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} placeholder={t('Email')} label={t(`Email`)} fieldProps={registerForm.getFieldProps('contactInformation.email')} fieldMeta={registerForm.getFieldMeta('contactInformation.email')} fieldHelper={registerForm.getFieldHelpers('contactInformation.email')} edit={true} dataLoaded={true} />
                </motion.div>
                <motion.div className="w-full flex px-5 flex-col my-5 justify-center">
                    <p className="text-xl font-bold text-primeColor">{t('Present Address')}</p>
                </motion.div>
                <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldInput injectClass={'bg-white'} label={t(`Pincode`)} fieldProps={registerForm.getFieldProps('contactInformation.presentAddress.pinCode')} fieldMeta={registerForm.getFieldMeta('contactInformation.presentAddress.pinCode')} fieldHelper={registerForm.getFieldHelpers('contactInformation.presentAddress.pinCode')} edit={true} dataLoaded={true} onChange={(ev) => getPresentAddress(ev)} />
                    <FieldInput injectClass={'bg-white'} label={t('Address Line 1')} fieldProps={registerForm.getFieldProps('contactInformation.presentAddress.addressLine1')} fieldMeta={registerForm.getFieldMeta('contactInformation.presentAddress.addressLine1')} fieldHelper={registerForm.getFieldHelpers('contactInformation.presentAddress.addressLine1')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`Address Line 2`)} fieldProps={registerForm.getFieldProps('contactInformation.presentAddress.addressLine2')} fieldMeta={registerForm.getFieldMeta('contactInformation.presentAddress.addressLine2')} fieldHelper={registerForm.getFieldHelpers('contactInformation.presentAddress.addressLine2')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`City`)} fieldProps={registerForm.getFieldProps('contactInformation.presentAddress.city')} fieldMeta={registerForm.getFieldMeta('contactInformation.presentAddress.city')} fieldHelper={registerForm.getFieldHelpers('contactInformation.presentAddress.city')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`District`)} fieldProps={registerForm.getFieldProps('contactInformation.presentAddress.district')} fieldMeta={registerForm.getFieldMeta('contactInformation.presentAddress.district')} fieldHelper={registerForm.getFieldHelpers('contactInformation.presentAddress.district')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} label={t(`State`)} fieldProps={registerForm.getFieldProps('contactInformation.presentAddress.state')} fieldMeta={registerForm.getFieldMeta('contactInformation.presentAddress.state')} fieldHelper={registerForm.getFieldHelpers('contactInformation.presentAddress.state')} edit={true} dataLoaded={true} />
                    <motion.div className="flex flex-row w-full items-center">
                        <input type="checkbox" defaultChecked={registerForm.values.contactInformation.isSameAddress} onChange={(ev) => sameAddress(ev)} />&nbsp;{t('Present Address is your native address')}
                    </motion.div>
                </motion.div>
                <motion.div className="w-full flex px-5 flex-col my-5 justify-center">
                    <p className="text-xl font-bold text-primeColor">{t('Native Address')}</p>
                </motion.div>
                <motion.div className="w-full h-full grid grid-cols-1 md:grid-cols-4 sm:grid-cols-1 gap-5">
                    <FieldInput injectClass={'bg-white'} disabled={registerForm.values.contactInformation.isSameAddress} label={t(`Pincode`)} fieldProps={registerForm.getFieldProps('contactInformation.nativeAddress.pinCode')} fieldMeta={registerForm.getFieldMeta('contactInformation.nativeAddress.pinCode')} fieldHelper={registerForm.getFieldHelpers('contactInformation.nativeAddress.pinCode')} edit={true} dataLoaded={true} onChange={(ev) => getNativeAddress(ev)} />
                    <FieldInput injectClass={'bg-white'} disabled={registerForm.values.contactInformation.isSameAddress} label={t('Address Line 1')} fieldProps={registerForm.getFieldProps('contactInformation.nativeAddress.addressLine1')} fieldMeta={registerForm.getFieldMeta('contactInformation.nativeAddress.addressLine1')} fieldHelper={registerForm.getFieldHelpers('contactInformation.nativeAddress.addressLine1')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} disabled={registerForm.values.contactInformation.isSameAddress} label={t(`Address Line 2`)} fieldProps={registerForm.getFieldProps('contactInformation.nativeAddress.addressLine2')} fieldMeta={registerForm.getFieldMeta('contactInformation.nativeAddress.addressLine2')} fieldHelper={registerForm.getFieldHelpers('contactInformation.nativeAddress.addressLine2')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} disabled={registerForm.values.contactInformation.isSameAddress} label={t(`City`)} fieldProps={registerForm.getFieldProps('contactInformation.nativeAddress.city')} fieldMeta={registerForm.getFieldMeta('contactInformation.nativeAddress.city')} fieldHelper={registerForm.getFieldHelpers('contactInformation.nativeAddress.city')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} disabled={registerForm.values.contactInformation.isSameAddress} label={t(`District`)} fieldProps={registerForm.getFieldProps('contactInformation.nativeAddress.district')} fieldMeta={registerForm.getFieldMeta('contactInformation.nativeAddress.district')} fieldHelper={registerForm.getFieldHelpers('contactInformation.nativeAddress.district')} edit={true} dataLoaded={true} />
                    <FieldInput injectClass={'bg-white'} disabled={registerForm.values.contactInformation.isSameAddress} label={t(`State`)} fieldProps={registerForm.getFieldProps('contactInformation.nativeAddress.state')} fieldMeta={registerForm.getFieldMeta('contactInformation.nativeAddress.state')} fieldHelper={registerForm.getFieldHelpers('contactInformation.nativeAddress.state')} edit={true} dataLoaded={true} />
                </motion.div>
            </motion.div>
            <motion.div className="h-full w-full overflow-scroll grid grid-cols-1 gap-10">
                <motion.div className="w-full flex px-1 gap-2 flex-col h-full py-5 justify-center">
                    <p className="text-4xl font-bold text-primeColor">{t('Upload Images and Horoscope Information')}</p>
                </motion.div>
                <motion.div className="h-full">
                    <p className="px-2 text-xl font-bold text-primeColor">{t('Upload Image')}</p>
                    <Dropzone className="relative my-5"
                        onChange={updateFiles}
                        value={files}
                        accept="image/*"
                        maxFiles={5}
                    >
                        {files.map((file) => (
                            <FileMosaic preview={true} key={file.id} {...file} onDelete={removeFile} info />
                        ))}
                    </Dropzone>
                </motion.div>
                <motion.div className="h-full gap-2 w-full">
                    <p className="px-2 text-xl font-bold text-primeColor">{t('Upload Horoscope')}</p>
                    <motion.div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 gap-1">
                        <RasiKattam setRasiValues={(ev) => setRasiValues(ev)} rasiValues={rasiValues} />
                        <AmsaKattam setAmsaValues={(ev) => setAmsaValues(ev)} amsaValues={amsaValues} />
                    </motion.div>
                </motion.div>
                <motion.div className="w-full flex flex-row justify-end">
                    <motion.div className="w-96 flex flex-row justify-start">
                        <Button injectClass={'rounded-full w-full'} type="secondary" onClick={() => history.goBack()}>{t('Back')}</Button>
                        <Button injectClass={'rounded-full w-full'} type="primary" onClick={() => registerForm.submitForm()}>{t('Submit')}</Button>
                    </motion.div>
                </motion.div>
            </motion.div>
            {/* <Dialog title="Preview Registration" showDialog={previewDialog} onClose={() => { setPreviewDialog(false); localStorage.removeItem('registerValues') }}>
                <motion.div className={'flex flex-col relative w-full h-full'}>
                    <motion.div className="py-10">
                        <PreviewRegistration registerValues={registerForm.values} />
                    </motion.div>
                    <motion.div className="flex py-2 flex-row w-full items-center absolute inset-x-0 bottom-0 justify-center">
                        <motion.div className={`w-fit ${submitDisabled ? 'cursor-not-allowed' : 'cursor-pointer'} px-2 py-1 rounded-full drop-shadow-lg bg-primeColor text-white`} onClick={() => !submitDisabled && registerForm.submitForm()}>
                            Register
                        </motion.div>
                    </motion.div>
                </motion.div>
            </Dialog > */}
        </motion.div >
    )
}

export default CreateUser